export default __webpack_public_path__ + "static/media/img-digital-cash-horizontal.09346b41.jpg";